module.exports = __webpack_public_path__ + "static/media/kiel.5c240963.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/squadImg/kiel.jpg
// module id = 741
// module chunks = 0